import './historicalExecutionBadge.css'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useContextSelector } from 'use-context-selector'
import { IconSeekers } from 'ui-seeker/core'
import { AppReportExecutionContext } from 'app/providers'

// "Historical data" badge of the Analyzer headers, left of "Last update": the selected report execution is older
// than the ClickHouse retention and its data is read from BigQuery (CU-869fa4gn3)
export default function AppHistoricalExecutionBadge() {
    const { t } = useTranslation('common')
    const isHistorical = useContextSelector(AppReportExecutionContext, ({ state }) => state.isHistorical)

    if (!isHistorical) return null

    return <span className="historical-execution-badge">
        <IconSeekers icon="history" iconType="fontAwesome" />
        <span>{t('reportExecution.historical.badge')}</span>
    </span>
}
